// https://stackoverflow.com/a/18157551
export function distance(
  rect: {
    min: {
      x: number;
      y: number;
    };
    max: {
      x: number;
      y: number;
    };
  },
  p: { x: number; y: number }
) {
  const dx = Math.max(rect.min.x - p.x, 0, p.x - rect.max.x);
  const dy = Math.max(rect.min.y - p.y, 0, p.y - rect.max.y);
  return Math.sqrt(dx * dx + dy * dy);
}
